import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Card, CardBody, CardTitle, Col, Container, Row } from 'reactstrap';
import ExcelImport from './ExcelImport';

const UploadSubscriberExcel = ({ dispatch, vendor }) => {
  const { t } = useTranslation('common'); 
  const location = useLocation();

  return (
    <Container>      
      <Row className="product-table-wrap">        
          <Col sm="12">           
            <ExcelImport />          
          </Col>
      </Row>
    </Container>
  )
};

UploadSubscriberExcel.propTypes = {
  dispatch: PropTypes.func.isRequired,
  vendor: PropTypes.number.isRequired
}

export default connect(state => ({
  rtl: state.rtl,
}))(UploadSubscriberExcel);